import { render, staticRenderFns } from "./handShake.vue?vue&type=template&id=6c9fdc60&scoped=true&"
import script from "./handShake.vue?vue&type=script&lang=js&"
export * from "./handShake.vue?vue&type=script&lang=js&"
import style0 from "./handShake.vue?vue&type=style&index=0&id=6c9fdc60&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c9fdc60",
  null
  
)

export default component.exports